(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morphyk-piece"]) return;
  try {
    
document.addEventListener('click',event=>{
const link=event.target.closest('.mk-piece a[href^="#"]');if(!link)return;
const target=document.getElementById(link.getAttribute('href').slice(1));if(target&&target.tagName==='DETAILS')target.open=true;
});

  } catch(e) { console.error(e); }
})();
})();
